var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nc_course" }, [
    _c("div", { staticClass: "nc_title" }, [
      _c("p", { staticClass: "nc_title_L" }, [_vm._v("精品课程")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "nc_title_more" },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  path: "/perfectCourseList",
                  query: { perfectPosition: _vm.perfectPosition }
                }
              }
            },
            [_vm._v("[ 查看更多精品课程... ]")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ncc_main" }, [
      _c(
        "ul",
        _vm._l(_vm.perfectCourseList, function(item, index) {
          return _c(
            "li",
            { class: [(index + 1) % 4 == 0 ? "mr-0" : ""] },
            [
              _c(
                "router-link",
                {
                  staticClass: "nccm_pic",
                  attrs: {
                    target: "_blank",
                    to: {
                      path: "/videoPlayer",
                      query: { cId: item.id, p: true }
                    },
                    title: item.name
                  }
                },
                [
                  _c("img", {
                    attrs: { src: item.imageUrl, width: "196", height: "133" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nccm_text textover",
                  attrs: {
                    target: "_blank",
                    to: {
                      path: "/videoPlayer",
                      query: { cId: item.id, p: true }
                    },
                    title: item.name
                  }
                },
                [_vm._v(_vm._s(item.name))]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "nccm_disk",
                  attrs: {
                    target: "_blank",
                    to: {
                      path: "/videoPlayer",
                      query: { cId: item.id, p: true }
                    },
                    title: item.name
                  }
                },
                [
                  _c("strong", [_vm._v(_vm._s(item.name))]),
                  _c("br"),
                  _c("br"),
                  _vm._v(_vm._s(item.ybsRbacUser.nickName))
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "nc_title_S" }, [
      _c("span", [_vm._v("成都中医药大学 — 为您提供最优课程")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a12b7d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a12b7d0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PerfectCourseSimpleList.vue
// module id = null
// module chunks = 